import { render, staticRenderFns } from "./DatasetPreviewModal.vue?vue&type=template&id=bbffda98&scoped=true&"
import script from "./DatasetPreviewModal.vue?vue&type=script&lang=js&"
export * from "./DatasetPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPreviewModal.vue?vue&type=style&index=0&id=bbffda98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbffda98",
  null
  
)

export default component.exports